'use strict';

bbw.directive.bbwPassword = function() {

    return {
        scope: {
            ngModel: '=bbwPassword',
            addClass: '@',
            inputClass: '@',
            toggleClass: '@',
            name: '@',
            placeholder: '@',
            required: '=',
            minLength: '='
        },
        templateUrl: bbw.templateUrl('bbw-password.html'),
        link: function(scope, element) {
            scope.showPassword = false;
            scope.toggleShowPassword = function () {
                scope.showPassword = !scope.showPassword;
                element.find("input")[0].focus();
            };
        }
    };

};